
export const mockScenarios =  [
    {
        id: "SCN001",
        name: "İadeler",
        active: true,
        createdOn: "2024-11-01",
        description: "Ürün veya ürünlerin iadesi",
        conditions: [
            {
                field: "type",
                operator: "eq",
                value: "return"
            },
            {
                field: "total_item_return_count",
                operator: "gte",
                value: 1
            }
        ]
    },
    {
        id: "SCN002",
        name: "Tek ürün iceren fişler",
        active: true,
        createdOn: "2024-11-05",
        description: "Makbuzun tek ürüne sahip olmasi",
        conditions: [
            {
                field: "type",
                operator: "eq",
                value: "sales"
            },
            {
                field: "item_count",
                operator: "eq",
                value: 1
            }
        ]
    },
    {
        id: "SCN003",
        name: "Fiş İptali",
        active: true,
        createdOn: "2024-11-10",
        description: "Ayni gün icinde magazada yapilan süpheli iptaller",
        conditions: [
            {
                field: "type",
                operator: "eq",
                value: "void"
            },
            {
                field: "total_void_count",
                operator: "gte",
                value: 3
            }
        ]
    },
    {
        id: "SCN004",
        name: "Manuel Fiyat Değişiklikleri",
        active: true,
        createdOn: "2024-11-15",
        description: "Kasiyer tarafindan degistirilmis fiyatlar",
        conditions: [
            {
                field: "type",
                operator: "eq",
                value: "modification"
            },
            {
                field: "total_modification_count",
                operator: "gt",
                value: 3
            }
        ]
    },
    {
        id: "SCN005",
        name: "İndirimli ürünlü fişler",
        active: true,
        createdOn: "2024-11-20",
        description: "Birden fazla yada farkli indirim olan ürünler",
        conditions: [
            {
                field: "type",
                operator: "eq",
                value: "reduction"
            },
            {
                field: "custom_reduction_count",
                operator: "gte",
                value: 2
            }
        ]
    },
    {
        id: "SCN006",
        name: "Nakit Ödeme",
        active: true,
        createdOn: "2024-11-25",
        description: "Kabul edilmeyen ödeme yöntemleri",
        conditions: [
            {
                field: "type",
                operator: "eq",
                value: "sales"
            },
            {
                field: "tenderType",
                operator: "eq",
                value: "cash"
            },
        ]
    },
    {
        id: "SCN007",
        name: "Sadakat Kartı Kullanımı",
        active: true,
        createdOn: "2024-11-25",
        description: "3ten fazla ayni günde ayni kartin kullanilmasi",
        conditions: [
            {
                field: "type",
                operator: "eq",
                value: "sales"
            },
            {
                field: "custom_loyalty_card_usage",
                operator: "gte",
                value: 3
            }
        ]
    },
    {
        id: "SCN008",
        name: "Anormal uzun süreli işlemler",
        description: "Normal süreden daha uzun süren islemler",
        active: true,
        createdOn: "2024-11-25",
        conditions: [
            {
                field: "type",
                operator: "eq",
                value: "sales"
            },
            {
                field: "duration",
                operator: "gt",
                value: 180
            }
        ]
    },
    {
        id: "SCN009",
        name: "Toplu Satış",
        description: "Belirli bir miktarin üstündeki satislar",
        active: true,
        createdOn: "2025-03-29",
        conditions: [
            {
                field: "type",
                operator: "eq",
                value: "sales"
            },
            {
                field: "total_gross_amount",
                operator: "gt",
                value: 10000
            }
        ]
    }
];

